import { render } from "./ListInlineItem.vue?vue&type=template&id=6f9f99a2"
import script from "./ListInlineItem.vue?vue&type=script&lang=js"
export * from "./ListInlineItem.vue?vue&type=script&lang=js"
script.render = render

export default script